// Enables us to lazily load external JS scripts
// Very minimalist, simply designed to support modern browsers and very basic, JS-only loading
export const asyncLoaderServiceModule = angular
  .module('Q.services.async-loader-service', [])

  .factory('asyncLoaderService', function ($document, $q) {
    const loaded = {};

    return {
      load,
    };

    /**
     * Asynchronously loads a remote script., and returns a promise for when that script
     * is loaded (or fails to load).
     *
     * @param url URL of remote script (raw)
     * @param attributes
     * @returns {Promise}
     */
    function load(url, attributes = {}) {
      if (!loaded[url]) {
        loaded[url] = _create(url, attributes);
      }
      return loaded[url];
    }

    function _create(url, attributes) {
      return $q((resolve, reject) => {
        let $node = angular.element('<script>');
        let node = $node[0];
        $node.attr(
          angular.extend(
            {
              type: 'text/javascript',
              charset: 'utf-8',
              async: true,
            },
            attributes,
          ),
        );

        node.addEventListener('load', () => resolve(), false);
        node.addEventListener(
          'error',
          () => reject('Unable to load ' + url),
          false,
        );

        node.src = url;
        $document.find('body').append($node);
      });
    }
  });
